import { listToArray } from 'src/lib/utils.js';

(function(){
    'use strict';
    

    let simulation_panel_exists = !!document.querySelector('.simulation-panel__wrapper');

    if (simulation_panel_exists) {

        let simulation_panels = listToArray(document.querySelectorAll('.simulation-panel__wrapper'));

        simulation_panels.forEach(simulation_panel => {

            initSimulationPanelToggle(simulation_panel);

            initClickOutsideClose(simulation_panel);
            
            initTokenExpiry(simulation_panel);

            initContentButtons(simulation_panel);

            initPanelContentBackButton(simulation_panel);

            initToggleButtons(simulation_panel);

        });

    }

    
}());

function initContentButtons(simulation_panel) {
    let js_buttons = listToArray(document.querySelectorAll('.js-button-toggle'));

    js_buttons.forEach(button => {

        button.addEventListener('click', () => {

            let visible_element = simulation_panel.querySelector(button["dataset"]["targetElement"]);

            visible_element["classList"].add('open');

            js_buttons.forEach(js_button => {

                js_button["classList"].add('hidden');

            })


        });

    });
}

function initTokenExpiry(simulation_panel) {
    let token_expiry = simulation_panel.querySelector('.token-exp-count');

    var duration = moment.duration(2 * 60 * 60 * 1000, 'milliseconds');
    var interval = 1000;

    setInterval(function () {
        duration = moment.duration(duration - interval, 'milliseconds');
        token_expiry.textContent = duration.hours() + ":" + duration.minutes() + ":" + duration.seconds();
    }, interval);
}

function initClickOutsideClose(simulation_panel) {
    document.addEventListener('click', (event) => {

        var isClickInside = simulation_panel.contains(event.target);

        if (!isClickInside) {

            simulation_panel["classList"].remove('simulation-panel__wrapper--open');

        }

    });
}

function initSimulationPanelToggle(simulation_panel) {
    let simulation_panel_toggle_buttons = listToArray(simulation_panel.querySelectorAll('.simulation-panel__toggle'));

    let simulation_panel_close_buttons = listToArray(simulation_panel.querySelectorAll('.simulation-panel__dialogue__back__button'));

    simulation_panel_toggle_buttons.forEach(button => {

        button.addEventListener('click', () => {

            simulation_panel["classList"].toggle('simulation-panel__wrapper--open');

        })

    });

    simulation_panel_close_buttons.forEach(simulation_panel_close_button => {

        simulation_panel_close_button.addEventListener('click', () => {

            simulation_panel["classList"].toggle('simulation-panel__wrapper--open');

        })

    });
}

function initPanelContentBackButton(simulation_panel) {
    let content_back_buttons = listToArray(simulation_panel.querySelectorAll('.simulation-panel__dialogue__content__back'));

    content_back_buttons.forEach(content_back_button => {

        content_back_button.addEventListener('click', () => {

            let open_panels = listToArray(simulation_panel.querySelectorAll('.open'));

            open_panels.forEach(open_panel => {

                open_panel["classList"].remove('open');

            });

            let simulation_panel_content_buttons = listToArray(document.querySelectorAll('.js-button-toggle'));

            simulation_panel_content_buttons.forEach(simulation_panel_button => {

                simulation_panel_button["classList"].remove('hidden');

            });

        })

    });
}

function initToggleButtons(simulation_panel) {

    let dropdown_sections = listToArray(simulation_panel.querySelectorAll('.js_dropdown_section'));

    dropdown_sections.forEach(dropdown_section => {

        let toggle_button = dropdown_section.querySelector(".simulation-panel__dropdown--toggle");
        let section = dropdown_section.querySelector(".simulation-panel__dropdown--section");

        toggle_button.addEventListener('click', () => {

            toggle_button["classList"].toggle("open");
            section["classList"].toggle("open");

        });

    });

}